import type { Tab } from '../../Toolkit/TabSelector/TabSelector';
import { VERTICAL, VERTICAL_LABELS } from '../../../helpers/verticals';
import styled from 'styled-components';

const TabItem = styled.span`
  ${({ theme }) => theme.fontSize.M16}
`;

export const TABS: Tab<VERTICAL>[] = [
  {
    label: <TabItem>{VERTICAL_LABELS[VERTICAL.MOTOR]}</TabItem>,
    value: VERTICAL.MOTOR,
  },
  {
    label: <TabItem>{VERTICAL_LABELS[VERTICAL.MARKETPLACE]}</TabItem>,
    value: VERTICAL.MARKETPLACE,
  },
  {
    label: <TabItem>{VERTICAL_LABELS[VERTICAL.FARMING]}</TabItem>,
    value: VERTICAL.FARMING,
  },
];

export const GO_FURTHER_OPTIONS = [
  {
    name: 'find-a-dealer',
    displayName: 'Find a Dealer',
  },
  {
    name: 'instant-offer',
    displayName: 'Sell My Car to a Dealer',
  },
  {
    name: 'sell-my-car',
    displayName: 'How to Sell My Car',
  },
  { name: 'value-my-car', displayName: 'Value My Car' },
  {
    name: 'greenlight-history-check',
    displayName: 'Vehicle History Check',
  },
  {
    name: 'buying-guide',
    displayName: 'Buying Guide',
    link: 'https://hello.donedeal.ie/hc/en-us/sections/201282821',
  },
  {
    name: 'electric-cars',
    displayName: 'Electric Vehicle Hub',
  },
  {
    name: 'blog',
    displayName: 'View our Blog',
    link: 'https://blog.donedeal.ie',
  },
];

export const LAST_SEARCH_DATA_TRACKING_VALUE = 'last_search_home_page';
